import React from "react";

const Container = ({ className = "", children }) => {
  return (
    <div className={`mx-auto w-full max-w-page px-5 md:px-8 ${className}`}>
      {children}
    </div>
  );
};

export default Container;
